import { __awaiter, __extends, __generator } from "tslib";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck extend InMemoryCache to create a fake one
import { ApolloCache } from '@apollo/client';
var VoidCache = /** @class */ (function (_super) {
    __extends(VoidCache, _super);
    function VoidCache() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VoidCache.prototype.read = function (_options) {
        return null;
    };
    VoidCache.prototype.write = function (_options) {
        return undefined;
    };
    VoidCache.prototype.diff = function (_options) {
        return {};
    };
    VoidCache.prototype.watch = function (_options) {
        return function () { return undefined; };
    };
    VoidCache.prototype.reset = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, undefined];
            });
        });
    };
    VoidCache.prototype.evict = function (_options) {
        return false;
    };
    VoidCache.prototype.restore = function (_options) {
        return this;
    };
    VoidCache.prototype.extract = function (_options) {
        return {};
    };
    VoidCache.prototype.removeOptimistic = function (_options) {
        return undefined;
    };
    VoidCache.prototype.batch = function (_options) {
        return undefined;
    };
    VoidCache.prototype.performTransaction = function (_update, _optimisticId) {
        return undefined;
    };
    VoidCache.prototype.transformDocument = function (document) {
        return document;
    };
    VoidCache.prototype.transformForLink = function (document) {
        return document;
    };
    VoidCache.prototype.identify = function (_options) {
        return undefined;
    };
    VoidCache.prototype.gc = function () {
        return [];
    };
    VoidCache.prototype.modify = function (_options) {
        return false;
    };
    return VoidCache;
}(ApolloCache));
export default VoidCache;
//# sourceMappingURL=voidCache.js.map